import React, { useState, useRef, useEffect } from 'react';
import { Bell } from 'lucide-react';
import { useNotifications } from '../context/NotificationContext';
import { useNavigate } from 'react-router-dom';

export default function NotificationBell(){
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const { notifications, unreadCount, markRead, removeNotification } = useNotifications();

  useEffect(() => {
    function onDoc(e){ if(ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('click', onDoc);
    return () => document.removeEventListener('click', onDoc);
  }, []);

  const handleNotificationClick = (notification) => {
    markRead(notification.id);
    if (notification.link) {
      navigate(notification.link);
      setOpen(false);
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen(v=>!v)} className="p-2 rounded hover:bg-white/10 relative">
        <Bell size={18} />
        {unreadCount > 0 && <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">{unreadCount > 99 ? '99+' : unreadCount}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-white rounded shadow-lg overflow-hidden z-50">
          <div className="p-3 border-b text-sm font-semibold flex items-center justify-between">
            <span>Notifications</span>
            {unreadCount > 0 && <span className="text-xs text-gray-500">{unreadCount} unread</span>}
          </div>
          <div className="max-h-96 overflow-y-auto">
            {notifications.length === 0 && <div className="p-3 text-sm text-gray-500">No notifications</div>}
            {notifications.map(n => (
              <div 
                key={n.id} 
                className={`p-3 border-b text-sm cursor-pointer hover:bg-gray-50 ${n.read ? 'bg-white' : 'bg-blue-50'}`}
                onClick={() => handleNotificationClick(n)}
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <div className="font-semibold text-gray-900">{n.title}</div>
                      {!n.read && <span className="w-2 h-2 bg-blue-600 rounded-full"></span>}
                    </div>
                    <div className="text-gray-600 mt-1">{n.message}</div>
                    <div className="text-xs text-gray-400 mt-2">{new Date(n.created_at).toLocaleString()}</div>
                  </div>
                  <button 
                    onClick={(e) => { e.stopPropagation(); removeNotification(n.id); }} 
                    className="text-gray-400 hover:text-red-600 ml-2"
                  >
                    ×
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
